/* eslint-disable no-void */

import * as vp from 'vopay';

import { useEffect, useState } from 'react';
import axios from 'axios';

import vopayApi from '../../services/api.config';
import { useDataFetchIndicator } from '..';

type HookProps = {
  api: vp.Api;
  bearer: string;
};

type HookTuple = [response: vp.CreditCardTransactionResponse, fetchData: (params: string) => void, reset: () => void];
type ApiHook = (props: HookProps) => HookTuple;

const useFetchCreditCardTransaction: ApiHook = ({ api, bearer }: HookProps) => {
  const source = axios.CancelToken.source();

  const [params, setParams] = useState<string>('');
  const [response, setResponse] = useState<vp.CreditCardTransactionResponse>({
    Success: false,
    ErrorMessage: '',
    FailureReason: '',
    TransactionID: '',
    TransactionStatus: vp.TransactionStatus.SUCCESSFUL,
    TransactionDateTime: '',
    Amount: '',
    Currency: 'CAD',
    HoldAmount: '',
    CreditCardToken: '',
    Country: '',
    ClientReferenceNumber: '',
    Notes: '',
    LastModified: '',
    GLCode: '',
    TransactionTypeCode: '',
  });
  const [shouldSendRequest, setSendRequest] = useState(false);
  const [, setDataFetchingInfo] = useDataFetchIndicator();

  useEffect(() => {
    const sendRequest = async () => {
      setDataFetchingInfo(true, 'Loading Data', 'fullScreen');

      const res = await api.fetchCreditCardTransaction({ TransactionID: params }, bearer, source);

      setResponse(res);
      setSendRequest(false);
      setDataFetchingInfo(false);

      return () => {};
    };

    if (params && shouldSendRequest) void sendRequest();

    return () => {
      source.cancel();
    };
  }, [shouldSendRequest]);

  return [
    response,
    (_params: string) => {
      setParams(_params);
      setSendRequest(true);
    },
    () => {
      setResponse({
        Success: false,
        ErrorMessage: '',
        FailureReason: '',
        TransactionID: '',
        TransactionStatus: vp.TransactionStatus.SUCCESSFUL,
        TransactionDateTime: '',
        Amount: '',
        Currency: 'CAD',
        HoldAmount: '',
        CreditCardToken: '',
        Country: '',
        ClientReferenceNumber: '',
        Notes: '',
        LastModified: '',
        GLCode: '',
        TransactionTypeCode: '',
      });
      setSendRequest(false);
    },
  ];
};

export default vopayApi.withApiHook<HookProps, HookTuple>(useFetchCreditCardTransaction);
